import axios from '@axios';
import HelperService from '@/services/HelperService';

const baseUrl = 'api/v1/social-visits/restricted-booking-dates';
const helperService = new HelperService();

export default {
  getRestrictedSocialDates(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${baseUrl}${queryString}`);
  },
  getFutureRestrictedDates() {
    return axios.get(`${baseUrl}/future-for-prison`);
  },
  createDate(dto) {
    return axios.post(`${baseUrl}/create-for-prison`, dto);
  },
  updateDate(id, dto) {
    return axios.post(`${baseUrl}/update/${id}`, dto);
  },
  deleteDate(id) {
    return axios.delete(`${baseUrl}/delete/${id}`);
  },
}
